export default __webpack_public_path__ + "static/media/images-oakwood-school-logotype-white.6c51275d.svg";